import { Timeouts } from '../../framework/Timeouts';
export class NovastarHSeriesBase {
    constructor(log) {
        this.log = log;
        this.firmwareVersion = '1.0.0.0';
        this.presets = [];
        this.timeouts = new Timeouts();
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /{"cmd":\s*"R0100",\s*"param0":\d+/i,
                callback: (match) => {
                    const resp = [
                        {
                            deviceId: 0,
                            modelId: 29953,
                            name: '',
                            status: 0,
                            protoVersion: this.firmwareVersion,
                            MAC: '00-23-5A-15-99-42',
                            volt: 0,
                            temp: 0,
                            extSignal: 0,
                            dataVersion: 0,
                            cmd: 'R0100',
                            ack: 'Ok',
                        },
                    ];
                    this.send(JSON.stringify(resp));
                },
            },
            {
                name: 'brightnessSet',
                regExp: /{"cmd":\s*"W0410",\s*"screenId":\s*\d+,\s*"deviceId":\s*(\d+),\s*"brightness":\s*(\d+)/i,
                callback: (match) => {
                    const resp = [
                        {
                            cmd: 'W0410',
                            deviceId: 0,
                            ack: 'Ok',
                        },
                    ];
                    this.send(JSON.stringify(resp));
                },
            },
            {
                name: 'screenLayerQuery',
                regExp: /{"cmd":\s*"R0500",\s*"param0":\d+/i,
                callback: (match) => {
                    const resp = [
                        {
                            deviceId: 0,
                            screenId: 0,
                            screenLayers: [{ name: 'Layer 1', layerId: 0 }],
                            cmd: 'R0500',
                            ack: 'Ok',
                        },
                    ];
                    this.send(JSON.stringify(resp));
                },
            },
            {
                name: 'presetEnumerate',
                regExp: /{"cmd":"R0600", "param0":0, "param1":0/i,
                callback: (match) => {
                    const resp = [
                        {
                            deviceId: 0,
                            screenId: 0,
                            presets: this.presets,
                            cmd: 'R0600',
                            ack: 'Ok',
                        },
                    ];
                    this.send(JSON.stringify(resp));
                },
            },
            {
                name: 'recallPreset',
                regExp: /{"cmd":\s*"(.+)",\s*"screenId":\s*\d+,\s*"deviceId":\s*(\d+),\s*"presetId":\s*(\d+)/i,
                callback: (match) => {
                    const resp = [
                        {
                            cmd: match[1],
                            deviceId: parseInt(match[2], 10),
                            ack: 'Ok',
                        },
                    ];
                    this.send(JSON.stringify(resp));
                },
            },
            {
                name: 'invalid',
                regExp: /{"cmd":\s*(.+),.+/i,
                callback: (match) => {
                    const resp = [
                        {
                            deviceId: 0,
                            screenId: 0,
                            cmd: match[1],
                            ack: 'Error',
                        },
                    ];
                    this.send(JSON.stringify(resp));
                },
            },
        ];
        for (let i = 1; i <= 20; i++) {
            this.presets.push({
                presetId: i,
                deviceId: 0,
                createTime: `${Date.now()}`,
                startTime: '',
                screen3D: {
                    enable: 0,
                    type: 0,
                    LeftFirstThenRight: 0,
                    startPointUpdown: 540,
                    startPointLeftright: 960,
                    Emitter: 0,
                    delayTimeMs: 7,
                    delayTimeUs: 0,
                },
                name: `Preset ${i}`,
            });
        }
    }
    onConfigure(config) {
        this.timeouts.clearAll();
    }
}
